export * from './table.component';
export * from './table-database';
export * from './table-datasource';
export * from './table-model.interface';
export * from './table-action-color.enum';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/table/index.ts